import React, { useState, useEffect, useRef } from 'react';
import "../firebase.js";

import Cookies from 'js-cookie';
import { Helmet } from "react-helmet";
import './login.css';
import { useNavigate } from "react-router-dom"; 
import { Toast } from '../components_root/ToastContext.jsx';
import { Randomcode } from '../components_root/rendom_code.js';
import { Randomnumber } from '../components_root/rendom_number.js';
import { MdAccountCircle, MdClose, MdEdit, MdLogin, MdMessage, MdPassword, MdVerifiedUser } from 'react-icons/md';
import { Mobile_signIn, verifyMobileOTP, signInWithGoogle } from '../firebase.js';

import google from '../assets/google.png';  

export default function Login() {
  const navigate = useNavigate();
 
  const { Toastshow } = Toast();
 
  const [return_url, setReturnUrl] = useState("/");

  useEffect(() => {
    const sessionKey = Cookies.get("sessionkey");
    if (sessionKey) {
      navigate(-1);
      return;
    }
    // ✅ Read return URL from query params
    const params = new URLSearchParams(window.location.search);
    const url = params.get("return");

    setReturnUrl(url || "/");
  }, []); // 👈 run only once
  // Initialize Recaptcha
 

  const signInWithGoogle_handler = async () => {
    try {
      const res = await signInWithGoogle(); // ❌ remove parameters

      if (res?.success) {

        // if (window.history.length > 1) {
        //   window.history.back();

        //   // Wait a bit then reload
        //   // setTimeout(() => {
        //   //   window.location.reload();
        //   // }, 300);

        // } else { 
          window.location.href = "/";
        // }

      } else {
          window.location.href = "/";
      }

    } catch (err) {
      Toastshow(err?.message || "Google sign-in failed");
    }
  };

 
  return (
    <div>

      <Helmet>
        <title>Login | Aooz – India’s B2B Marketplace</title>

        <meta
          name="description"
          content="Securely log in to your Aooz account to manage products, connect with verified buyers, generate bulk leads, and grow your wholesale business across India."
        />

        <meta
          name="keywords"
          content="Aooz login, B2B marketplace login, supplier login India, manufacturer account login, wholesale seller login, buyer login Aooz, manage products online"
        />

        <meta name="author" content="Aooz" />
        <meta name="robots" content="index, follow" />

        {/* Canonical */}
        <link rel="canonical" href="https://aooz.in/login" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Login | Aooz – Access Your B2B Seller Dashboard"
        />
        <meta
          property="og:description"
          content="Log in to Aooz to manage your product listings, respond to buyer inquiries, and grow your wholesale business online."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://aooz.in/login" />
        <meta
          property="og:image"
          content="https://aooz.in/assets/logo.png"
        />


        <meta
          name="twitter:image"
          content="https://aooz.in/assets/logo.png"
        />
      </Helmet>

      <div className="container_roots " >
        <div className="container_size_info">
          <div className="form p-22 shade rounded shadow"  >
            <div className=" center text-hero-sub bold">
              Aooz
            </div>
            <div className="flex-column">
              <div className='text-h2  center'>Sign in to your account and  Take control of your business.  </div>
            </div>
          
        
            <div className='text-h3'>Log in to agree to the Terms and Conditions</div>
      

            <table className='table-fixed'>
              <tr>
                <td>
                  <div className="button-ui2 p-3 fill cursor" onClick={signInWithGoogle_handler}>
                    <img src={google} className='icon' /> Signup</div>
                </td>
                <td>
                  <div className="button-ui2 p-3 fill cursor" onClick={() => window.location.href = "https://aooz.in"}><MdClose className='icon' />Cancel</div>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div id="recaptcha-container"></div>
      </div>
    </div >
  );
}
